// src/components/RemoteTile.jsx

import React, { useEffect, useRef, useState } from "react";

function attach(el, stream) {
  if (!el || !stream) return;
  try {
    if (el.srcObject !== stream) el.srcObject = stream;
const play = () => el.play().catch((e) => {
  console.warn("[RemoteTile] play() failed:", e?.name, e?.message);
});
    if (el.readyState >= 2) play();
    else el.onloadedmetadata = play;
  } catch {}
}

export default function RemoteTile({
  peerId,
  stream,
  soundEnabled, // globaal: remote audio aan/uit
  tileAspect = "4 / 3",
  registerAudioEl,
  // 🔊 nieuw:
  volume = 1, // 0.0 – 1.0
  muted = false,
  onVolumeChange,
  onToggleMute,
}) {
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const [showControls, setShowControls] = useState(false);
  const hideTimerRef = useRef(null);

  // 🔥 NEW: detecteer of er al een live video track is (voor "Verbinden…" overlay)
  const hasLiveVideo =
    !!stream && stream.getVideoTracks().some((t) => t.readyState === "live");

  // Video
  useEffect(() => {
    attach(videoRef.current, stream);
  }, [stream]);

  // Audio
  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;


   // altijd registreren (ook als sound nog uit staat)
if (registerAudioEl) registerAudioEl(a);

if (stream) {
  attach(a, stream);
  a.muted = !soundEnabled || !!muted;
  a.volume = Math.max(0, Math.min(1, volume));

} else {
  // global sound uit → alleen muten, NOOIT srcObject loskoppelen
  a.muted = true;
}


return () => {
  // NIET deregistreren bij rerender; alleen bij unmount
};


  }, [soundEnabled, stream, registerAudioEl, muted, volume]);

  const wrapperStyle = {
    position: "relative",
    background: "#000",
    borderRight: "1px solid #020617",
    borderBottom: "1px solid #020617",
    height: "100%",
    width: "100%",
    overflow: "hidden",
  };

  const innerStyle = {
    position: "absolute",
    inset: 0,
    background: "#000",
  };

  const videoStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transform: "scaleX(-1)", // remote gespiegeld
    display: "block",
    background: "#000",
  };

  function handleMouseEnter() {
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    setShowControls(true);
  }

  function handleMouseLeave() {
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    // na ~1s weer verbergen
    hideTimerRef.current = setTimeout(() => {
      setShowControls(false);
    }, 1000);
  }

  function handleVolumeInput(e) {
    const v = Number(e.target.value) / 100;
    if (onVolumeChange) onVolumeChange(peerId, v);
  }

  function handleToggleMuteClick(e) {
    e.stopPropagation();
    if (onToggleMute) onToggleMute(peerId);
  }

  return (
    <div
      style={wrapperStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div style={innerStyle}>
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          disablePictureInPicture
          style={videoStyle}
          aria-label={`Remote video ${peerId}`}
        />

        {/* ✅ NEW: subtiele overlay tot er echt videoframes kunnen komen */}
        {!hasLiveVideo && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#e5e7eb",
              fontSize: 13,
              background: "rgba(0,0,0,0.35)",
              backdropFilter: "blur(2px)",
              pointerEvents: "none",
            }}
          >
            Verbinden…
          </div>
        )}

        {/* onzichtbare audio-tag voor remote audio */}
<audio
  ref={audioRef}
  autoPlay
  playsInline
  preload="auto"
  style={{ display: "none" }}
/>

        {/* 🔊 Hover-mixer: verschijnt alleen bij hover */}
        {typeof onVolumeChange === "function" && (
          <div
            style={{
              position: "absolute",
              bottom: 8,
              right: 8,
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 8px",
              borderRadius: 999,
              background: "rgba(0,0,0,0.55)",
              backdropFilter: "blur(4px)",
              opacity: showControls ? 1 : 0,
              pointerEvents: showControls ? "auto" : "none",
              transition: "opacity 150ms ease-out",
            }}
          >
            <button
              type="button"
              onClick={handleToggleMuteClick}
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                color: "#f9fafb",
                cursor: "pointer",
                fontSize: 16,
                lineHeight: 1,
              }}
            >
              {muted || !soundEnabled ? "🔇" : "🔊"}
            </button>
            <input
              type="range"
              min="0"
              max="100"
              value={Math.round(volume * 100)}
              onChange={handleVolumeInput}
              style={{
                width: 70,
                cursor: "pointer",
                accentColor: "#f9fafb",
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
    </div>
  );
}
